import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AppStatic, ContentService } from '../_core';
import { LcpHelper } from '../_core/_helpers/lcp-helper';
import { ActivatedRoute, Router } from '@angular/router';

import { fromEvent, combineLatest, Subject } from "rxjs";
import { map, takeUntil } from "rxjs/operators";

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit, OnDestroy {

  @ViewChild('projectsSizing') projectsSizing: ElementRef
  @ViewChild('projectsContainerOuter') projectsContainerOuter: ElementRef

  slug = 'work'
  content: any
  projects: any
  fields: any

  filters: any[] = [] // isActive, display, tag
  filterGroups: any = []
  activeFilterGroup: any
  activeFilterGroupNames: any[] = []

  activeFilters: any[] = []

  queryParam$: any
  queryParams: any = {}

  placeholder: string = 'no results'

  showProjects: boolean = false
  // tagNameLookup = LcpHelper.tagNameLookup

  windowResize$: any
  destroy$: Subject<boolean> = new Subject<boolean>();



  constructor(
    private cdr: ChangeDetectorRef,
    public contentService: ContentService,
    public lcpHelper: LcpHelper,
    public route: ActivatedRoute,
    public router: Router
  ) { }

  ngOnInit(): void {
    this.getPage()
    // this.queryParam$ = 
    this.queryParamStream()
    // this.windowResize$ = 
    this.windowResizeStream()
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
    // if (this.queryParam$) this.queryParam$.unsubscribe()
    // if (this.windowResize$) this.windowResize$.unsubscribe()
  }
  
  getPage(){
    this.contentService.getPage({'fields.slug': this.slug })
    .pipe(takeUntil(this.destroy$))
    .subscribe({
        next: (content) => {
          this.content = content
          if (!this.content) return console.log('!content', this.content)
          let firstItem = this.content.items[0]
          // console.log('content, first item', this.content, firstItem)
          this.fields = this.content.items[0].fields     
          // console.log('projects-fields', this.fields)     
          this.placeholder = this.fields['placeholder'] || LcpHelper.defaultListPlaceholderHTML

          this.updateFiltersFromFields(this.fields)
          // console.log('fg', this.filterGroups);
        }
    });
  }

  queryParamStream() {
    this.route.queryParams
    .pipe(takeUntil(this.destroy$))
    .subscribe(qp => {
      this.queryParams = qp
      // console.log('qp', qp)
      this.updateActiveFiltersFromQueryParams()
      this.fadeOutProjects().then(res => {
        this.updateProjects()
      })
    })
  }

  windowResizeStream() {
    if (!AppStatic.isBrowser) return
    const width = fromEvent(window, "resize").pipe(map(() => window.innerWidth));
    const height = fromEvent(window, "resize").pipe(map(() => window.innerHeight));
    const combined = combineLatest([width, height]);
  
    const dimensions = combined.pipe(
      // throttleTime(100),
      map(([width, height]) => ({ width, height }))
    )
  
    return dimensions
    .pipe(takeUntil(this.destroy$))
    .subscribe(res => {
      // console.log('WINDOW DIM', res)
      this.updateProjectsContainerHeight()
    }) 
  }


  updateFiltersFromFields(fields: any) {
    // RM: information & environmental design
    // RM: strategic outreach
    
    this.filterGroups = this.fields['filterGroups']
    // console.log('CHECK filterGroups', this.filterGroups)
    this.filterGroups.map((group:any) => {
      if (!group.fields.items) return
      for (let filter of group.fields.items) {
        filter.metadata['filterGroupName'] = group.fields['name']
        return filter
        // console.log('filter', group, filter)
      }
    })
    this.updateActiveFiltersFromQueryParams()
  }

  updateProjects() {
    this.contentService.getProjects(this.projectsQueryFromQueryParams())
    .subscribe({
        next: (projects) => {
          // this.projects = this.sortSequence(projects.items, 'title')
          if (!projects) {
            console.log('!projects', projects)
            // return setTimeout(this.updateProjectsNow.bind(this, 1000), 1000)
          }
          // console.log('UPN')
          return this.updateProjectsNow(projects)
          // console.log('updateProjects', this.projects, projects);
          return projects
        }
    });
  }

  updateProjectsNow(projects, delay?) {
    if (!projects || !projects.items) return console.log('ERR: !projects', projects)
    // console.log('PROJ', projects)
      
    projects = this.sortSequence(projects.items, 'title')

    projects.map(project => {
      // hide unless src (cover image) set

      if (!project.metadata) console.log('NO METADATA...')
      project.metadata ||= {}
      if (project.fields['media']) project.metadata['src'] = this.urlFromMedia(project.fields['media'][0])
      project.metadata['innerHtml'] = this.lcpHelper.htmlFromRichText(project.fields['tagline'])
      return project
    })

    // remove if no cover src
    // if (!project.metadata['src']) return
    this.projects = projects.filter(p => !!p.metadata['src'])

    setTimeout(this.fadeInProjects.bind(this), 100);

    if (this.projectsSizing) setTimeout(this.updateProjectsContainerHeight.bind(this), 100)

    // console.log('projectsSizing', this.projectsSizing.nativeElement, this.projectsSizing.nativeElement.offsetHeight)

    this.detectChanges()
    return this.projects
  }

  updateProjectsContainerHeight() {
    const offsetHeight = this.projectsSizing.nativeElement.offsetHeight
    // console.log('offsetHeight', offsetHeight)
    // this.projectsContainerOuter.nativeElement.style.minHeight = `${offsetHeight}px`
    this.projectsContainerOuter.nativeElement.style.height = `${offsetHeight}px`

    this.detectChanges()
  }

  sortSequence(sequence: any[], field: string) {
    return AppStatic.sortSequence(sequence, field) // sequence.sort((a, b) => a.fields[field].localeCompare(b.fields[field]))
  }

  projectsQueryFromQueryParams() {
    // console.log('projectsQueryFromQueryParams', this.queryParams, this.projects, this.queryParams['tag'] )
    // this.queryParams
    if (!this.queryParams['tag']) return {}
    return {
      'metadata.tags.sys.id[in]': Array(this.queryParams['tag']),
      // 'metadata.tags.sys.id[in]': Array(this.queryParams['tag']),
    }
  }

  fadeOutProjects() {
    // console.log('FADE OUT')
    this.showProjects = false
    this.detectChanges()
    return this.lcpHelper.delay(100).then(() => null)
  }

  fadeInProjects() {
    this.showProjects = true
    this.detectChanges()
  }

  filterDataFromParams(params:any = {}) {
    if (params['filter']) {
      let filter = params['filter']
      return { type: filter.fields['type'], 
               name: filter.fields['name'],
               filterGroup: filter.fields['filterGroup'] }
    }
    return { type: params['type'], name: params['name'] }
  }

  updateActiveFiltersFromQueryParams() {
    if (!this.queryParams) return
    this.activeFilters = []
    for (let key of Object.keys(this.queryParams)) {
      // console.log('SET', key, this.queryParams[key], Array(this.queryParams[key]), Array.isArray(this.queryParams[key]))
      if (Array.isArray(this.queryParams[key])) {
        for (let name of this.queryParams[key]) {
          this.activeFilters.push(this.filterDataFromParams({ type: key, name: name }))
        }
      } else {
        this.activeFilters.push(this.filterDataFromParams({ type: key, name: this.queryParams[key]}))
      }
    }

    // console.log('activeFilters', this.activeFilters)
    this.updateActiveFilterGroupsFromActiveFilters(this.activeFilters)
  }

  filterIsActive(filter: any): boolean {
    return !!this.activeFilters.find(x => x['name'] === filter.fields['name'])
  }

  projectCoverBackgroundImage(project: any) {
    // project.fields['media'][0].fields.file.url
    return this.lcpHelper.backgroundImageFromMedia(project.fields['media'][0])
  }

  projectPath(project: any) {
    return AppStatic.projectPath(project) // '/work/' + project.fields['slug']
  }

  handleSelectFilterGroup(filterGroup: any) {
    if (!filterGroup || filterGroup.isOpen) return this.resetFilters()

    this.filterGroups.map((fg: any) => fg.isOpen = false)

    // select 'all' resets filters
    if (!filterGroup.fields['items']) return this.resetFilters()

    filterGroup.isOpen = true
    this.activeFilterGroup = filterGroup
  }

  resetFilters() {
    this.activeFilterGroup = null
    this.filterGroups.map((fg: any) => fg.isOpen = false)
    return this.updateRouteFromNewFilters(null)
  }

  handleSelectFilter(filter: any) {
    // const tagsFromContentful = this.contentService.getTags()
    // console.log('handleSelectFilter', Object.assign({}, filter))
    filter.isActive = !!filter.isActive ? false : true
    let newFilters = [] 
    let filterData = this.filterDataFromParams({ filter: filter })
    // console.log('FILTER', Object.assign({}, filter))
    if (!this.filterIsActive(filter)) {
      newFilters.push(filterData)
    } else {
      newFilters = [] 
      // newFilters = this.removeFromActiveFiltersGroup(newFilters, filterData) // removed so only one selection possible
    }
    newFilters = newFilters.filter(this.lcpHelper.onlyUnique)
    // console.log('newFilters', Object.assign([], newFilters))
    this.updateRouteFromNewFilters(newFilters)
  }

  removeFromActiveFiltersGroup(group: any, filterData: any) {
    return group.filter((el: any) => {
      return !(el['name'] === filterData['name'] && el['type'] === filterData['type'])
    })
  }


  updateActiveFilterGroupsFromActiveFilters(activeFilters: any[]) {
    let groupNames = []

    for (let activeFilter of activeFilters) {
      // console.log(this.filterGroups.)
      this.filterGroups.map(fg => {
        fg.fields?.items?.map(filter => {
          // console.log('filter', filter.fields?.name == activeFilter.name, filter.fields?.name, filter.fields?.filterGroup)
          if (filter.fields?.name == activeFilter.name) groupNames.push(filter.fields?.filterGroup)
        })
      })
    }
    this.activeFilterGroupNames = groupNames.filter(this.lcpHelper.onlyUnique)
    // console.log('activeFilterGroupNames', this.activeFilterGroupNames, activeFilters, groupNames)

    for (let filterGroup of this.filterGroups) {
      let lc = String(filterGroup.fields['name']).toLowerCase()
      // let lcIndex = this.activeFilterGroupNames.indexOf(lc)
      // active all active-filter groups
      filterGroup['isActive'] = this.activeFilterGroupNames.indexOf(lc) > -1
      // open first filter group
      if (filterGroup['isActive'] && !this.activeFilterGroup) {
        this.activeFilterGroup = filterGroup
        filterGroup['isOpen'] = true
      }
      // console.log('lc', lc, filterGroup, lcIndex, this.activeFilterGroupNames)
    }
    this.detectChanges()
  }

  updateRouteFromNewFilters(filters: any) {
    // console.log('urff', filters, this.queryParams)
    let newQueryParams:any = {} // Object.assign({}, this.queryParams)

    let value:any[] = []
    if (filters) filters.map((filter: any) => {
      // console.log('val', value)
      if (!Array.isArray(value)) value = Array(value)
      value.push(filter['name'])
      value = value.filter(this.lcpHelper.onlyUnique)
      // newQueryParams = Object.assign({}, this.queryParams)
      newQueryParams[filter['type']] = value
      // console.log('nqp', newQueryParams, value)
    })

    // console.log('QP', newQueryParams, filters)
    return this.router.navigate([], { 
      queryParams: newQueryParams }) 
      // queryParamsHandling: 'merge' })
  }

  urlFromMedia(media: any) {
    return this.lcpHelper.urlFromMedia(media)
  }

  detectChanges() {
    if (!this.cdr['destroyed']) this.cdr.detectChanges()
  }
}
